import {BaseElementBuilder} from './BaseElementBuilder'
import {SlotElementBuilder} from './SlotElementBuilder'
import type {Builder, DalValue, ManifestFeature, Pointer} from '@wix/document-services-types'
import type {ElementItem, Actions, CustomActions, DisplayFilters} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

export interface ElementBuilderData {
    type: string
    role: string
    data: DalValue
    actions: Actions
    customActions: CustomActions
    displayFilters: DisplayFilters
    manifest?: ManifestFeature
    pointer: Pointer
    rootContainerPointer: Pointer
    elementsDefaults: Builder.ElementsDefaults
    customTypeMapper?(elementType: string, compPointer: Pointer): string | undefined
}

export class ElementBuilderFactory {
    constructor(private data: ElementBuilderData) {}

    create(): ElementItem | undefined {
        if (this.data.type === SlotElementBuilder.SLOT_TYPE) {
            return new SlotElementBuilder(this.data).buildElement()
        }

        return new BaseElementBuilder(this.data).buildElement()
    }
}
